// NOTE: Mirrors apps/nsai/server/src/app-config/feature-flag-keys.ts (the
// authoritative copy). Web and mobile both consume this file, so keep it in
// lockstep with the server when adding or changing entries — drift is silent
// and shows up as features appearing disabled in the UI. Mobile only reads
// the subset of fields its UI cares about; extra entries here are inert.
export const FLAG_KEYS = {
  isBillingDisabled: "a3f72b",
  maxFileUploadCount: "9c1e44",
  isTelegramBotEnabled: "c4d77e",
  isWhatsappBotEnabled: "a7d3f1",
  isWhatsappBotEnabledFF: "e4b19c",
  isMatrixBotEnabled: "6e2b90",
  isAudioTranscriptionEnabled: "5b8e10",
  isExternalServiceForAudioTranscription: "f2a649",
  isKonturTalkEnabled: "813dc5",
  isYandexTelemostEnabled: "27c9f4",
  isSaluteJazzEnabled: "6d05b8",
  isFinancialMaskingFeatureEnabled: "9a31c7",
  // NOTE: NSAI-6434 — TEMP_DEEP_RESEARCH_V2_ENABLED: the clients show the
  // Deep Research budget settings only where a run would honour them.
  isDeepResearchV2Enabled: "18a723",
  isPiiCustomEntitiesFeatureEnabled: "b7e29d",
  isPiiAdvancedRulesFeatureEnabled: "cc845f",
  isPiiIntentRoutingFeatureEnabled: "3c7f5e",
  isAgentsEnabled: "e07b2f",
  isCustomIntegrationEnabled: "3c8f1a",
  isAnonymizationLabEnabled: "d81f3a",
  isAnonymizationLabEnabledFF: "e5c204",
  isDocRecognitionEnabled: "b1e64d",
  isBrandedPresentationsEnabled: "5f1c93",
  isTokenUsageEnabled: "4a8b91",
  isTokenCostUsageEnabled: "7b3e6f",
  isTokenLimitsEnabled: "3e7d52",
  isSyncatorApiEnabled: "9b4e2c",
  isSkillsEnabled: "7c3e58",
  isSkillScriptExecutionAvailable: "b2f47a",
  isAdminPanelEnabled: "d59a31",
  isZipArchiveUploadEnabled: "f4b90c",
  isUserMemoryEnabled: "d2b7a4",
  jitsiCustomDomains: "62fe48",
  isTtsEnabled: "1a8c93",
  isExternalServiceForTts: "4e5fbd",
  ttsVoices: "9c47e1",
  enabledCalendars: "70b3a9",
  isCallAssistantFeaturesEnabled: "4a1e8d",
  isCallAssistantFeaturesEnabledFF: "8e3d52",
  isExternalIntegrationsProviderEnabled: "2f9b67",
  isSSOVisible: "1a4b6c",
  isSamlSeatTiersEnabled: "5c9d13",
  isSiemExportEnabled: "7c3ea5",
  isMobileChatSearchEnabled: "8f24b1",
  isSiemGlobalCollectorActive: "6ba413",
  isModelApprovalEnabled: "c6a80b",
  isDomainVerificationUnavailable: "3a6f82",
  slackBotUri: "7e2a91",
  teamsBotUri: "bc5f08",
  // NOTE: NSAI-5752 — the support address the app shows users, served here
  // rather than baked into each client at build time. A store build pins one
  // API URL and cannot be rebuilt per customer, so an on-premise deployment
  // has to be able to set its own contact without shipping a new binary.
  supportEmail: "4d8e07",
  // NOTE: NSAI-5934 — the chat-map tile server, served here for the same
  // reason as supportEmail above: a published UI image and a store build
  // cannot be rebuilt per installation, so a value baked into them could never
  // point at a customer's own tile server. Absent means the basemap is off.
  mapTileUrl: "4cea9e",
  mapTileAttribution: "755e48",
  mapMaxZoom: "c62a8c",
  // NOTE: NSAI-5881 — the deployment block: one nested object describing the
  // tenant (on-premise or not, flavor, sign-in paths, AI providers, analytics,
  // legal links, policies) so a single store build can serve every server.
  // Like jitsiCustomDomains it is a payload under one obfuscated key; the
  // fields inside it are readable and carry nothing secret.
  deployment: "dd96e4",
} as const;
